export const analytics = {
  botWise: {
    botWiseAnalytics: 'Analitika e Botit-Sipas',
    currentBillingCycle: 'Cikli i Tanishëm i Faturimit',
    currentMonth: 'Muaji i Tanishëm',
    sinceAccountCreation: 'Që nga Krijimi i Llogarisë',
    messages: 'Mesazhet',
    leads: 'Udhëheqësit',
    noDataFound: {
      botwiseAnalytics: 'Analitika e Botit-Sipas',
      noBotHasBeenCreatedYet: 'Ende nuk është krijuar asnjë bot!',
    },
    appTooltip: {
      TOOLTIP_BOTWISE_SUMMARY: 'Përmirësoni të dhënat nga mesazhet dhe kontaktet/udhëheqësit për botët specifike për ciklin aktual të faturimit, muajin aktual, ose që nga krijimi i llogarisë (Përditësohet çdo natë)',
      TOOLTIP_FILTERS: 'Filtro të dhënat për botin e zgjedhur',
      TOOLTIP_MESSAGES: 'Totali i mesazheve të konsumuara nga llogaria juaj që nga krijimi i llogarisë',
      TOOLTIP_LEADS: 'Totali i udhëheqësve të kapur nga botët për llogarinë tuaj që nga krijimi i llogarisë.',
    }
  },
  overview: {
    analytics: 'Analitika',
    seeHowToUse: 'Shiko se si të përdoret',
    help: 'Ndihmë',
    overview: 'Përmbledhje',
    messages: 'Mesazhet',
    leads: 'Udhëheqësit',
    appTooltip: {
      TOOLTIP_OVERVIEW_TITLE: 'Analiza për të gjitha mesazhet dhe udhëheqësit e botëve tuaj. (Të dhënat përditësohen çdo natë)',
    }
  },
  summary: {
    analyticsSummary: 'Përmbledhje Analitike',
    allBots: 'Të Gjitha Botët',
    daily: 'Ditorë',
    weekly: 'Javorë',
    monthly: 'Mujorë',
    messages: 'Mesazhet',
    leads: 'Udhëheqësit',
    appTooltip: {
      TOOLTIP_ANALYTICS_SUMMARY: 'Përmirësoni të dhënat ditore, javore ose mujore nga mesazhet dhe kontaktet/udhëheqësit për botët specifike dhe të gjitha (Përditësohet çdo natë)',
    }
  },
  whatsapp: {
    analyticsCount: {
      whatsappAnalytics: 'Analitika e WhatsApp',
      month: 'Muaji',
      week: 'Jjava',
      today: 'Sot',
      filters: 'Filtra',
      clearAll: 'Pastro të Gjitha',
      apply: 'Apliko',
      totalConversations: 'Totali i Bisedave',
      freeConversations: 'Biseda Pa Pagesë',
      paidConversations: 'Biseda të Paguara',
      messageSent: 'Mesazhet e Dërguara',
      messageDelivered: 'Mesazhet e Dorëzuara',
      bpDropDown: {
        selectBot: 'Zgjidhni Botin',
      },
      indexMergeDatePicker: {
        startDate: 'Data e Fillimit',
        endDate: 'Data e Përfundimit',
      }
    },
    conversationAnalytics: {
      conversationAnalytics: 'Analitika e Bisedave',
      month: 'Muaji',
      week: 'Jjava',
      today: 'Sot',
      totalConversations: 'Totali i Bisedave',
      paidConversations: 'Biseda të Paguara',
      freeConversations: 'Biseda Pa Pagesë',
      indexMergeDatePicker: {
        startDate: 'Data e Fillimit',
        endDate: 'Data e Përfundimit',
      },
      bpDropDown: {
        allBots: 'Të gjitha botët'
      }
    },
    messageAnalytics: {
      whatsappMessages: 'Mesazhet e WhatsApp',
      sent: 'Dërguar',
      delivered: 'Dorëzuar',
      indexMergeDatePicker: {
        startDate: 'Data e Fillimit',
        endDate: 'Data e Përfundimit',
      },
      bpDropDown: {
        allBots: 'Të gjitha botët'
      },
      month: 'Muaji',
      week: 'Jjava',
      today: 'Sot',
    },
    messageStatusAnalytics: {
      whatsappMessagesByStatus: 'Mesazhet e WhatsApp Sipas Statusit',
      sent: 'Dërguar',
      delivered: 'Dorëzuar',
      indexMergeDatePicker: {
        startDate: 'Data e Fillimit',
        endDate: 'Data e Përfundimit',
      },
      bpDropDown: {
        allBots: 'Të gjitha botët'
      },
      month: 'Muaji',
      week: 'Jjava',
      today: 'Sot',
    },
    newWhatsappAnalytics: {
      allSubscribers: 'Të Gjitha Abonentët',
      whatsappSubscribers: 'Abonentët e WhatsApp'
    }
  }
};
